import Chip, { type ChipProps } from '@mui/material/Chip';

export const minColumnWidth = 190;

export const memberStatuses = {
  connected: 'Connected',
  notConnected: 'Not connected',
} as const;

export const memberStatusOptions = [
  {
    label: memberStatuses.connected,
    value: memberStatuses.connected,
  },
  {
    label: memberStatuses.notConnected,
    value: memberStatuses.notConnected,
  },
];

export const getMemberStatusValue = ({
  authUserId,
}: {
  authUserId: string | null;
}) => {
  if (authUserId) {
    return memberStatuses.connected;
  }

  return memberStatuses.notConnected;
};

export const renderMemberStatusCell = (value: string) => {
  let color: ChipProps['color'] = 'success';

  if (value === memberStatuses.notConnected) {
    color = 'error';
  }

  if (!value) {
    return null;
  }

  return (
    <Chip
      color={color}
      label={value}
      size="small"
      variant="outlined"
    />
  );
};
